class AvailablePathService {
  constructor (http) {
    this.http = http
  }

  async downloadFile (url) {
    const response = await this.http.get(url, { responseType: 'blob' })
    const blob = new Blob([response.data], { type: 'application/pdf' })
    const link = document.createElement('a')
    link.setAttribute('target', '_blank')
    link.href = URL.createObjectURL(blob)
    link.click()
    URL.revokeObjectURL(link.href)
  }
}

export default AvailablePathService
